import React from 'react';
import { mlColor, secAgo } from '../helpers';
import { T } from '../constants';

// TIER strategies put the verdict in `action_label`, not `action`. Prefer it.
const verdict = d => d.action_label || d.action;

export default function StatsRow({ decisions }) {
  const trades   = decisions.filter(d => verdict(d) === 'TRADE');
  const observes = decisions.filter(d => verdict(d) === 'OBSERVE');
  const active   = trades.length + observes.length; // TRADE + OBSERVE both = active signal
  const avgML   = decisions.length
    ? (decisions.reduce((s, d) => s + (parseFloat(d.ml_score) || 0), 0) / decisions.length).toFixed(1)
    : null;
  const last    = decisions[0]?.signal_ts;
  const elapsed = secAgo(last);

  const tiles = [
    {
      label: 'Decisions',
      value: decisions.length,
      sub:   `${trades.length}T · ${observes.length}OBS`,
      color: T.blue,
    },
    {
      label: 'Active Rate',
      value: decisions.length ? `${Math.round(active / decisions.length * 100)}%` : '—',
      sub:   `${trades.length}T ${observes.length > 0 ? `+ ${observes.length}OBS` : ''}`.trim(),
      color: observes.length > 0 ? T.purple : T.bull,
    },
    {
      label: 'Avg ML',
      value: avgML ?? '—',
      sub:   `${decisions.length} signals`,
      color: avgML ? mlColor(avgML) : T.textMuted,
    },
    {
      label: 'Last Signal',
      value: elapsed !== null ? `${elapsed}s` : '—',
      sub:   elapsed !== null ? 'ago' : 'no data',
      color: elapsed !== null && elapsed < 60 ? T.bull : T.textDim,
    },
  ];

  return (
    <div className="stats-row">
      {tiles.map((t, i) => (
        <div key={i} className="stat-tile">
          <div className="stat-label">{t.label}</div>
          <div className="stat-value" style={{ color: t.color }}>{t.value}</div>
          <div className="stat-sub">{t.sub}</div>
        </div>
      ))}
    </div>
  );
}
